import gql from "graphql-tag";

const SUB_COUNT_BY_TYPE = gql`
    subscription formSubmissionCountByType($customer_type_id: Int!, $division_id: Int, $unresponded: Boolean, $unconverted: Boolean){
        formSubmissionCountByType(customer_type_id: $customer_type_id, division_id: $division_id, unresponded: $unresponded, unconverted: $unconverted)
    }
`;

export default SUB_COUNT_BY_TYPE;
